module.exports = __webpack_public_path__ + "img/prod-8.d00274b9.png";